module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "acknowledgments-title"
  }, [_c('strong', [_vm._v("ACKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Japanese Baseball” appeared in "), _c('em', [_vm._v("Dandelion")]), _vm._v(", and "), _c('em', [_vm._v("Iowa City Magazine")]), _vm._v(", and “Wavelengths” “The Arbiter” and “The Mansions of Federico Juarez” in "), _c('em', [_vm._v("Iowa City Magazine")]), _vm._v(". “The First and Last Annual Six Towns Area Old-Timers’ Game” was published as a collectors’ edition chapbook by Coffee House Press of Minneapolis. “The Lime Tree” was published by "), _c('em', [_vm._v("Elysian Fields Magazine")]), _vm._v(", and “Tulips” accepted by "), _c('em', [_vm._v("Dugout Magazine")]), _vm._v(". “The Kowloon Cafe” was accepted by Heartlands. “The Indestructable Hadrian Wilks” was anthologized in "), _c('em', [_vm._v("Baseball Fantastic")]), _vm._v(" published by Quarry Press, and published by Passages North. “Fred Noonan Flying Services” was anthologized in "), _c('em', [_vm._v("Baseball Fantastic")]), _vm._v(", and published by Westview.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "id": "page10"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7191aa1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0003.vue
// module id = 69
// module chunks = 0